import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";
import React from "react";
import { useIntl } from "react-intl";
import { COLOR_PRIMARY } from "../../../constants/theme";
import { WebFormResponseNotification } from "../../../cores/notifications/interfaces/api/get-notifications";

interface Props {
  notification: WebFormResponseNotification;
  variant?: "dropdown" | "page";
  isDarkMode?: boolean;
}

export default function WebFormResponseNotificationItem({
  notification,
  variant = "dropdown",
  isDarkMode = false,
}: Props) {
  const intl = useIntl();
  const title = notification.formName || notification.formTitle || "Formulario web";
  const subtitle = notification.contactName || notification.contactEmail || "";

  if (variant === "page") {
    return (
      <div
        className={cn("new-contact-notification-page", {
          "new-contact-notification-page--dark": isDarkMode,
        })}
      >
        <div className="new-contact-notification-page__icon">
          <FontAwesomeIcon icon={["fab", "wpforms"]} size="2x" color={COLOR_PRIMARY} />
        </div>
        <div className="new-contact-notification-page__body">
          <p className="new-contact-notification-page__eyebrow">
            {intl.formatMessage({ id: "app.notifications.kind.webFormResponse" })}
          </p>
          <p className="new-contact-notification-page__title">{title}</p>
          {subtitle ? (
            <p className="new-contact-notification-page__success">{subtitle}</p>
          ) : null}
          <p className="new-contact-notification-page__success">
            {notification.isNewContact
              ? intl.formatMessage({ id: "app.notifications.webFormResponse.newContact" })
              : intl.formatMessage({ id: "app.notifications.webFormResponse.existingContact" })}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="d-flex align-items-center border-bottom mb-1">
      <FontAwesomeIcon
        icon={["fab", "wpforms"]}
        className="mr-2"
        size="2x"
        color={COLOR_PRIMARY}
      />
      <div className="d-flex flex-column overflow-hidden">
        <span className="text-truncate">{title}</span>
        <span className="text-truncate text-secondary">
          {subtitle ||
            intl.formatMessage({ id: "app.notifications.webFormResponse.received" })}
        </span>
      </div>
    </div>
  );
}
